import { Formik } from "formik";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { TemplateLayout } from "./TemplateLayout";
import {
  CustomQuestionnaireTemplateInput,
  validationSchema,
} from "./custom-questionnaire/utils";
import { useSubmit } from "@certn/api";
import { showToast } from "@certn/cascadia";
import { CustomQuestionnaireTemplateForm } from "./custom-questionnaire/CustomQuestionnaireTemplateForm";

export function CustomTemplateCreationPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const goBack = () => navigate("/settings/custom-questionnaire-templates");

  const { submit } = useSubmit(
    `/api/internal/client-portal/custom-questionnaire-templates/create/`,
    {
      throwErrors: true,
      showToastOnError: true,
      onSuccess: () => {
        showToast(t("Template created successfully!"), { type: "success" });
        goBack();
      },
    }
  );

  const createTemplate = async (values: CustomQuestionnaireTemplateInput) => {
    if (!values.name) {
      showToast(t("Missing Required Fields: Template name"), {
        type: "error",
      });
      return;
    }

    await submit(values);
  };

  return (
    <Formik<CustomQuestionnaireTemplateInput>
      enableReinitialize
      validateOnMount
      initialValues={{
        name: "",
        questions: [],
      }}
      validationSchema={validationSchema}
      onSubmit={async (values) => {
        await createTemplate(values);
      }}
    >
      {({
        values,
        handleSubmit,
        isSubmitting,
        isValid,
        setValues,
        dirty,
        setFieldValue,
      }) => {
        return (
          <TemplateLayout
            type="create"
            title={t("Custom questionnaire template")}
            onComplete={handleSubmit}
            submitting={isSubmitting}
            onCancel={goBack}
            disableCompletion={!isValid || !dirty}
          >
            <CustomQuestionnaireTemplateForm
              type="create"
              values={values}
              setValues={setValues}
              setFieldValue={setFieldValue}
            />
          </TemplateLayout>
        );
      }}
    </Formik>
  );
}
